<template>
  <div v-if="botw && botw.user">
    <div class="h5">Tipper der Woche</div>
    <div class="card-sakali container">
      <div class="row">
        <div class="col-7 text-nowrap text-truncate">
          <div>
            <sakali-user :user="botw.user" :small="false"/>
          </div>
          <div class="mt-1" v-if="botw.user.team">
            <team-emblem :emblem-id="botw.user.team.emblemId" size="32"/>
            {{ botw.user.team.name }}
          </div>
        </div>
        <div class="col-5 text-nowrap text-end pt-1"
             :class="{'text-sakali-primary': !botw.finished}">
          {{ botw.points | float }} Punkte<br/>
          {{ botw.payout | kies }}
        </div>
        <div class="col-12 mt-1 text-muted small">{{ botw.user.slogan }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import sakaliApi from '../../sakali-api'

export default {
  props: {
    betPeriodId: Number
  },
  data() {
    return {
      botw: Object
    }
  },
  methods: {
    loadBotw() {
      sakaliApi.get('/botw/' + this.betPeriodId).then(response => {
        this.botw = response.data
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  },
  watch: {
    ...mapActions(['handleErrorAction']),
    betPeriodId() {
      this.loadBotw();
    }
  },
  mounted() {
    this.loadBotw();
  }
}
</script>
